module.exports = __webpack_public_path__ + "static/media/XY_Measurement.94513406.svg";